import { ArrowUp } from "lucide-react";
import { FadeUp } from "./Reveal";

const NAV = [
  { label: "Services", href: "#services", testid: "footer-link-services" },
  { label: "Work", href: "#work", testid: "footer-link-work" },
  { label: "About", href: "#about", testid: "footer-link-about" },
  { label: "Contact", href: "#contact", testid: "footer-link-contact" },
];

export const Footer = ({ onNavigate }) => (
  <footer className="border-t border-[#262626] overflow-hidden" data-testid="footer">
    <div className="max-w-[1800px] mx-auto px-6 sm:px-12 lg:px-24 pt-20">
      <div className="grid grid-cols-2 md:grid-cols-12 gap-10 pb-20">
        <div className="col-span-2 md:col-span-5">
          <FadeUp>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#FF3B00] mb-4">HQ</p>
            <p className="text-sm font-light leading-relaxed text-[#808080] max-w-xs">
              Serving the North — residential & commercial.
              Concrete pours May–October. Plows run all winter.
            </p>
          </FadeUp>
        </div>
        <div className="md:col-span-3">
          <FadeUp delay={0.05}>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#FF3B00] mb-4">Menu</p>
            <ul className="space-y-3">
              {NAV.map((l) => (
                <li key={l.href}>
                  <button
                    onClick={() => onNavigate(l.href)}
                    className="font-mono text-xs uppercase tracking-[0.2em] text-[#808080] hover:text-[#F2F2F2] transition-colors duration-300"
                    data-testid={l.testid}
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </FadeUp>
        </div>
        <div className="md:col-span-4">
          <FadeUp delay={0.1}>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#FF3B00] mb-4">Direct</p>
            <ul className="space-y-3">
              <li>
                <a href="tel:+14374533942" className="font-mono text-xs uppercase tracking-[0.2em] text-[#808080] hover:text-[#F2F2F2] transition-colors duration-300" data-testid="footer-phone-link">
                  +1 (437) 453-3942
                </a>
              </li>
              <li>
                <a href="mailto:northec24@gmail.com" className="font-mono text-xs uppercase tracking-[0.2em] text-[#808080] hover:text-[#F2F2F2] transition-colors duration-300" data-testid="footer-email-link">
                  northec24@gmail.com
                </a>
              </li>
              <li className="font-mono text-xs uppercase tracking-[0.2em] text-[#808080]">
                Snow dispatch — 24/7
              </li>
            </ul>
          </FadeUp>
        </div>
      </div>
    </div>

    <div className="relative border-t border-[#1A1A1A]">
      <FadeUp y={60}>
        <h2
          className="font-oswald font-bold uppercase text-center leading-[0.8] tracking-tighter text-[16.5vw] text-[#161616] select-none -mb-[0.12em]"
          data-testid="footer-giant-text"
        >
          NorthEdge
        </h2>
      </FadeUp>
    </div>

    <div className="border-t border-[#1A1A1A] bg-[#050505] relative z-10">
      <div className="max-w-[1800px] mx-auto px-6 sm:px-12 lg:px-24 py-6 flex flex-wrap items-center justify-between gap-4">
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#4A4A4A]">
          © 2026 NorthEdge Contracting. All rights reserved.
        </p>
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#4A4A4A]">
          Built in the North
        </p>
        <button
          onClick={() => onNavigate("#home")}
          className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.25em] text-[#808080] hover:text-[#FF3B00] transition-colors duration-300"
          data-testid="footer-back-to-top"
        >
          Back to top <ArrowUp className="h-3.5 w-3.5" />
        </button>
      </div>
    </div>
  </footer>
);
